import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ProgressCircleContainer = styled.div<{
  margin: boolean;
  opacity: number;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: ${Fonts['regular']};
  font-size: ${26 * Screen.widthRatio}px;
  height: ${58 * Screen.widthRatio}px;
  margin-left: ${(props) => (props.margin ? 16 : 0 * Screen.widthRatio)}px;
  opacity: ${(props) => props.opacity};
  width: ${58 * Screen.widthRatio}px;
`;

export default ProgressCircleContainer;
